<template>
  <div :class="containerClasses">
    <label :for="name">{{ label }}</label>
    <input
      type="text"
      :placeholder="label ? '' : placeholder"
      :id="name"
      autocomplete="new-password"
      :value="modelValue"
      @keydown="storeStatus"
      @input="setValue"
      @focus="focus"
      @blur="blur"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

import $formatter from '@/utils/format';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: null,
  },
  restrict: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: null,
  },
  modelValue: {
    type: String,
    default: null,
  },
  valid: Boolean,
});

const focused = ref(false);

function focus() {
  focused.value = true;
}

function blur() {
  focused.value = false;
}

function storeStatus(e) {
  e.target.dataset.origin = e.target.value;
  e.target.dataset.position = e.target.selectionEnd;
  e.target.dataset.input = e.key;
}

function setValue(e) {
  if (props.type === 'phone') {
    $formatter.formatToPhone(e);
  } else if (props.type === 'email') {
    $formatter.formatToEmail(e);
  }

  emit('update:modelValue', e.target.value);
}

const containerClasses = computed(() => {
  return {
    'form-input': true,
    focused: focused.value,
    filled: Boolean(props.modelValue),
    error: !props.valid,
  };
});

watch(
  () => props.modelValue,
  () => {
    if (!props.restrict) return;
    if (!props.valid) {
      emit('update:modelValue', null);
    }
  }
);
</script>

<style scoped>
.form-input {
  position: relative;
}

.form-input label {
  position: absolute;
  bottom: 0.2em;
  font-size: 1.1em;
  pointer-events: none;
  transition: all 0.2s;
}
.form-input.focused label,
.form-input.filled label {
  bottom: 3em;
  font-size: 0.65em;
}

.form-input input {
  margin-top: 1.8em;
  outline: none;
  border: 0 none;
  border-bottom: 1px solid #bbbdbf;
  width: 100%;
  height: 1.4em;
  padding: 0;
  background: none;
  color: #6d6e70;
  font-size: 1.1em;
  transition: color 0.2s ease;
}
.form-input:not(.focused).filled input {
  color: #76be45;
}
.form-input:not(.focused).error input {
  color: #df195f;
}

.form-input input::placeholder {
  color: rgba(99, 99, 99, 0.4);
}
</style>
